import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { identifyComponent } from '../../util';
import css from './index.module.scss';

export interface DividerProps {
  testId?: string;
  inset?: boolean;
  variant?: 'dark' | 'medium' | 'light';
  className?: string;
}

export const Divider: React.FC<DividerProps> = ({
  testId = 'divider',
  className,
  inset = false,
  variant = 'medium',
}) => (
  <hr
    data-component="Divider"
    data-testid={testId}
    className={classNames(css.divider, css[variant], className, {
      [css.inset]: inset,
    })}
    {...identifyComponent('divider')}
  />
);
